import { Model } from 'pinia-orm';
import { BelongsTo, Num, Str } from 'pinia-orm/dist/decorators';
import PackageTender from './PackageTender';
import PackageTradeItem from './PackageTradeItem';

export default class PackageTenderItem extends Model {
  static entity = 'App\\Models\\PackageTenderItem';

  @Num(0)
  declare id: number;
  @Num(0)
  declare package_tender_id: number;
  @Num(0)
  declare package_trade_item_id: number;
  @Num(undefined)
  declare rate: number | undefined;
  @Num(undefined)
  declare amount: number | undefined;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;

  @BelongsTo(() => PackageTender, 'package_tender_id', 'id')
  declare tender: PackageTender;
  @BelongsTo(() => PackageTradeItem, 'package_trade_item_id', 'id')
  declare package_trade_item: PackageTradeItem;
}
